<template>
    <div class="talent-level-container">
        <div class="list-wrap">
            <div class="block width-1">
                <router-link class="button is-success" :to="{name:'addCartRuleConfigEdit',query:{activityId:activityId}}">新增</router-link>
            </div>
            <div class="tile is-parent">
                <article class="tile is-child box">
                    <table class="table is-bordered">
                        <thead>
                        <tr>
                            <th>规则</th>
                            <th>奖品</th>
                            <th>操作</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in tableData" :key="index">
                            <td>活动期间加车次数=<span>{{item.count}}</span>次</td>
                            <td>{{item.prize}}</td>
                            <td>
                                <router-link class="button is-info" :to="{name:'addCartRuleConfigEdit',query:{activityId:activityId,ruleId:item.ruleId}}">编辑</router-link>
                                <button class="button is-danger"  @click="removePriceTag(item,index)">删除</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </article>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    export default{
        data(){
            return{
                tableData:[],
                activityId:null
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.activityId = parseInt(this.$route.query.activityId);
                this.getRuleList();
            })
        },
        methods:{
            /*
            * 点击删除触发
            * */
            removePriceTag(item,index){
                if (confirm('是否确定删除?')) {
                    HttpRequest.get("/admin.php?method=cartactivity.removeRule",{activityId:this.activityId,ruleId:item.ruleId},true).then((response)=>{

                        if(response.data.success == 1){
                            this.$message("删除成功!");
                            this.tableData.splice(index,1);
                        }
                    })
                }
            },
            getRuleList() {
                    HttpRequest.get('/admin.php?method=cartactivity.showRule', {activityId:this.activityId},true).then((response) => {
                    this.tableData = response.data.list;
                })
            },
        }
    }
</script>
<style lang="less" scoped>
    .list-box{
        margin-bottom: 20px;
    }
    .remark-col{
        width: 300px;
    }
    .marginRight{
        margin-right: 5px;
        margin-bottom: 5px;
    }
</style>
